<template>
  <div>
    <title>卡包提货</title>
    <section class="serviceBox">
      <!-- S 券卡验证表单 -->
      <el-form :model="serviceForm" inline class="serviceForm">
        <el-form-item class="formTimeSlot">
          <el-select v-model="serviceForm.verifyType">
            <el-option
              v-for="(item,index) in serviceTypeData"
              :label="item.name"
              :value="item.value"
              v-bind:key="item.value + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="codeSerIpt">
          <el-input
            v-show="serviceForm.verifyType == 0"
            maxlength="20"
            v-model.trim="serviceForm.cardCode"
            placeholder="填写券卡编码"
            clearable
            ref="codeRef"
            @keyup.enter.native="toNext(0)"
          ></el-input>
          <el-input
            v-show="serviceForm.verifyType == 1"
            v-model.trim="serviceForm.cardSerial"
            placeholder="填写序列号"
            clearable
            ref="serialRef"
            @keyup.enter.native="toNext(1)"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="validateLoading" @click="validate">验证</el-button>
        </el-form-item>
      </el-form>
      <!-- S 券卡验证表单 -->

      <!--S 验证券卡列表-->
      <div class="serviceWrap">
        <p class="commonTit">
          <b>券卡信息</b>
          <em>
            (已验证
            <i class="commonNum">{{cardVertifyData.length}}</i> 张)
          </em>
          <span class="goodsSummary iconsw" @click="goodsSummary = true" v-if="cardVertifyData.length>0 || cardOrderno">商品汇总</span>
        </p>
        <el-table
          ref="cvTable"
          class="comTable cardVertifyTab"
          border
          :data="cardVertifyData"
          :maxHeight="tableHeight"
        >
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column label="券卡编码" fixed min-width="200">
            <template slot-scope="scope">
              <p>{{ scope.row.code}}</p>
              <em v-show="scope.row.serial">【{{scope.row.serial}}】</em>
            </template>
          </el-table-column>
          <el-table-column label="本次消耗次数" min-width="200">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.consumpteTimes"
                v-on:change="consumpteTimesChange($event,scope.row)"
                size="mini"
                :min="1"
                :max="scope.row.residuenum"
                :step="1"
                step-strictly
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="剩余次数" prop="consumpteTimes" sortable min-width="130">
            <template slot-scope="scope">{{ scope.row.residuenum-scope.row.consumpteTimes}}</template>
          </el-table-column>
          <el-table-column label="已选商品" min-width="130">
            <template slot-scope="scope">
              <span
                class="cityName iconhand textFl"
                @click="getShowChoseGoods(scope.row)"
              >{{scope.row.goods.length}}</span>
            </template>
          </el-table-column>
          <el-table-column label="售卡渠道" prop="sellChannel" sortable min-width="120">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.sellChannel">{{ scope.row.sellChannel}}</p>
            </template>
          </el-table-column>
          <el-table-column label="面单打印说明" min-width="200">
            <template slot-scope="scope">
              <p
                class="textFl"
                :title="scope.row.printMemo"
              >{{scope.row.printMemo?scope.row.printMemo:'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="客服备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.memo">{{scope.row.memo?scope.row.memo:'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="出库备注" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.cardoutmemo">{{scope.row.cardoutmemo | empty}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <p class="handle">
                <span
                  v-if="scope.row.canChangeGoods"
                  title="更改商品"
                  @click="getShowChoseGoods(scope.row)"
                ><i class="iconedit"></i></span>
                <span title="删除" @click="deleteRow(scope.$index)"><i class="icondel"></i></span>
              </p>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData">
              <span>暂无数据</span>
            </div>
          </template>
        </el-table>
      </div>
      <!--E 验证券卡列表-->
      <div class="bottomBtn">
        <el-button type="primary" :loading="submitLoading" @click="submitDeliveryForm()">提交</el-button>
        <el-button @click="$router.back(-1)">返回</el-button>
      </div>
    </section>

    <!-- S 选择可选商品 -->
    <GoodsChoose
      v-if="goodsChoseDialogVisible"
      :delmode="0"
      :goodsChoseDialogVisible="goodsChoseDialogVisible"
      :lookOrEditType="lookOrEdit"
      :code="currentCode"
      :initUseTimes="currentUseTimes"
      :initSelectGoods="currentCodeInfo.goodsMap"
      :enAbleEdite="currentEnAbleEdite"
      @closeChild="getCloseGoodsCld"
      v-on:selectSubmit="goodsSelectSubmit($event)"
    ></GoodsChoose>
    <!-- E 选择可选商品 -->

    <!-- S 选择会员 -->
    <MemberChose
      v-if="memberChoseDialogVisible"
      :isAdd="1"
      :initSelected="bindMemberInfo"
      :memberChoseDialogVisible="memberChoseDialogVisible"
      @closeChild="getCloseMemberCld"
      v-on:selected="memberSelected($event)"
    ></MemberChose>
    <!-- E 选择会员 -->

    <!--S 商品汇总弹窗-->
    <GoodsSummary :goodsSummaryShow="goodsSummary" :orderno="cardOrderno" :cardData="cardVertifyData" :deliveryType="0" @closeSummaryBox="getCloseSummaryBox"></GoodsSummary>
    <!--E 商品汇总弹窗-->

    <!--S 提交成功提示框-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="submitDeliveryBox" append-to-body :close-on-click-modal="false" :before-close="closeSubmitPop">
      <div class="alertBox">
        <i class="el-icon-success"></i>
        <h2 class="comAlert">提货成功！</h2>
        <p>生成订单号：<em class="orangeColor cursorHand iconhand cityName" @click="orderCardInfo()" title="点击查看商品汇总">{{orderno}}</em></p>
        <small>点击订单号可查看当前订单所有商品汇总信息哦~</small>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="closeSubmitPop">关闭</el-button>
      </p>
    </el-dialog>
    <!-- E 提交成功提示框 -->
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "DoorDelivery",
  components: {
    GoodsChoose: resolve =>
      require(["@/components/OrderFolder/GoodsChoose.vue"], resolve), //选择可选商品
    MemberChose: resolve =>
      require(["@/components/common/MemberChose.vue"], resolve), //选择会员
    GoodsSummary: resolve => require(["@/components/OrderFolder/GoodsSummary.vue"], resolve), //商品汇总
  },
  data() {
    return {
      ischeckpwd: 0,
      pubordprintinfo: null,
      presellconfig: null,
      validateLoading: false,
      submitLoading: false,
      currentCode: "",
      currentUseTimes: 1,
      currentCodeInfo: null,
      firstTimes: false,
      currentEnAbleEdite: true,
      bindMemberInfo: null,
      serviceForm: {
        verifyType: 0, //验证类型,0:卡号，1:序列号
        cardCode: "", //券卡编码
        cardSerial: "" //序列号
      },
      goodsDateData: [],
      cardVertifyData: [],
      goodsChoseDialogVisible: false, //选择可选商品弹框
      lookOrEdit: false, //查看or更改商品
      memberBox: false, //已选会员
      memberChoseDialogVisible: false, //选择会员弹框
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      //-------------新加商品汇总弹窗信息---------------------
      goodsSummary:false,//商品汇总弹窗
      submitDeliveryBox:false,//提交成功的提示
      orderno:'',//订单号
      cardOrderno: '', // 传递给组件的订单号
    };
  },
  methods: {
    // enter键确认事件 type为对应的步数
    toNext(type) {
        this.validate();
    },
    validate: function() {
      let param = { pickway: this.serviceForm.verifyType };
      param.code =
        param.pickway === 0
          ? this.serviceForm.cardCode
          : this.serviceForm.cardSerial;

      if (!param.code) {
        Message.error({
          message: "请输入" + (param.pickway === 0 ? "券卡编码" : "券卡序列号")
        });
        return;
      }
      param.isfromcardbag =1
      this.validateLoading = true;
      Api.VALIDATE(param).then(res => {
          if(res.data.status == "202"){
             MessageBox.alert('券卡加入微信卡包后重新定义，本次提货请仔细核对会员账号！',"系统提示",
            {
              type: "success",
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true
            }
          ).then(() => {}).catch(() => {});
        }else if (res.data.status !== "200") {
            Message.error({ message: res.data.message });
            this.validateLoading = false;
            return;
          }
          let data = res.data.data;
          let codeinfo = data.codeinfo;

          let validateInfo = {
            code: codeinfo.code,
            serial: codeinfo.serial,
            sellChannel: codeinfo.channelname,
            printMemo: codeinfo.printmemo,
            memo: codeinfo.sermemo,
            cardoutmemo: data.memo,
            consumpteTimes: 1, // 默认1
            residuenum: codeinfo.residuenum,
            canChangeGoods: true,
            goods: []
          };

          this.currentEnAbleEdite = true;
          let needChooseGoods = true;
          if (data.resulttype === 0) {
            // 有默认商品，且默认商品状态可选，自动选择默认商品
            let resultinfo = data.resultinfo;
            if (resultinfo.defaultSetStatus === "000") {
              // 默认商品设置成功
              validateInfo.canChangeGoods = resultinfo.selgoods.length > 1;
              this.currentEnAbleEdite = resultinfo.selgoods.length > 1;
              validateInfo.goods = [resultinfo.selgoods[0]];
              validateInfo.goodsMap = { singleList: [resultinfo.selgoods[0]] };
              needChooseGoods = false;
              this.notForceGoodsOutDateLimitMessage(resultinfo.isoutgooddate);
            } else if (resultinfo.defaultSetStatus === "001") {
              // 只有默认商品设置失败
              MessageBox.confirm("券卡绑定商品不可用，默认商品不可用！", '系统提示', {
                confirmButtonText: '关闭',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {}).catch(() => {})
              // Message.warning({
              //   message: "券卡绑定商品不可用，默认商品不可用！"
              // });
              return;
            } else {
              // 有默认有可选，默认商品设置失败
              validateInfo.canChangeGoods = true;
              this.currentEnAbleEdite = true;
              needChooseGoods = true;
            }
          }
          if (needChooseGoods) {
            // 没有默认商品，弹出商品选择
            if (data.resultinfo.isoutcarddate === 1) {
              // this.$alert(
              //   "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！",
              //   "系统提示",
              //   {
              //     confirmButtonText: "确定",
              //     callback: action => {
              //       this.currentCode = codeinfo.code;
              //       this.currentUseTimes = validateInfo.consumpteTimes;
              //       this.currentCodeInfo = validateInfo;
              //       this.firstTimes = true;
              //       this.goodsChoseDialogVisible = true;
              //     }
              //   }
              // );
              MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.currentCode = codeinfo.code;
                this.currentUseTimes = validateInfo.consumpteTimes;
                this.currentCodeInfo = validateInfo;
                this.firstTimes = true;
                this.goodsChoseDialogVisible = true;
              }).catch(() => {})
            } else {
              this.currentCode = codeinfo.code;
              this.currentUseTimes = validateInfo.consumpteTimes;
              this.currentCodeInfo = validateInfo;
              this.firstTimes = true;
              this.goodsChoseDialogVisible = true;
            }
          } else {
            // 不强制限制券卡有效期
            this.notForceCardLimitMessage(data.resultinfo.isoutcarddate);
            this.cardVertifyData.push(validateInfo);
          }
          this.validateLoading = false;
          this.serviceForm.cardCode = "";
        })
        .catch(res => {
          this.validateLoading = false;
        });
    },
    notForceCardLimitMessage: function(iscardoutdate) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && iscardoutdate) {
        MessageBox.confirm("警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   offset: 75,
        //   message: "警示！该券卡不在有效期内，提货需按照企业当前发货政策进行！"
        // });
      }
    },
    notForceGoodsOutDateLimitMessage: function(isgoodsoutdate) {
      let forceDeliveryDate = this.pubordprintinfo.forcedeliverydate;
      if (forceDeliveryDate === 0 && isgoodsoutdate) {
        MessageBox.confirm("警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！", '系统提示', {
          confirmButtonText: '关闭',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        // Message.warning({
        //   message:
        //     "警示！默认商品不在销售日期内，提货需按照企业当前的发货政策进行！"
        // });
      }
    },
    consumpteTimesChange: function($event, item) {
      Api.SETCARDUSENUM({ code: item.code, usenum: $event }).then(res => {
        let status = res.data.status;
        if (status != 200) {
          item.consumpteTimes =
            $event - 1 > item.residuenum ? item.residuenum : $event - 1;
        }
      });
    },
    goodsSelectSubmit: function($event) {
      console.log("selectedGoodsDatas", $event);
      let param = { code: $event.code, usenum: $event.useTimes };
      let goodsInfo = $event.goodsinfo;
      let goodsInfos = [];
      let goodsMap = {};
      if ($event.type === 0) {
        // 有默认商品
        if ($event.selectDefaultGoods === 1) {
          param.isSelectDef = 1;
          param.defaultgoodscode = goodsInfo["singleList"][0].kindcode;
        } else {
          param.isSelectDef = 0;
          param.kindcodes = {};
          param.kindcodes["1"] = goodsInfo["singleList"][0].kindcode;
        }
        goodsInfos.push(goodsInfo["singleList"][0]);
        goodsMap["singleList"] = goodsInfo["singleList"];
      } else {
        // 无默认商品
        param.isSelectDef = 0;
        let kindcodes = {};

        for (let key in goodsInfo) {
          let kindcodeStr = [];
          for (let item of goodsInfo[key]) {
            kindcodeStr.push(item.kindcode);
            goodsInfos.push(item);
          }
          kindcodes[key.split("@")[1]] = kindcodeStr.join("@");
          goodsMap[key.split("@")[0]] = goodsInfo[key];
        }

        param.kindcodes = kindcodes;
      }

      this.currentCodeInfo.goods = goodsInfos;
      this.currentCodeInfo.kindcodes = param.kindcodes;
      this.currentCodeInfo.goodsMap = goodsMap;

      var hasValidateInfo = this.cardVertifyData.find(item => {
        if (item.code === this.currentCodeInfo.code) {
          return item;
        }
      });

      if (hasValidateInfo) {
        hasValidateInfo.goods = this.currentCodeInfo.goods;
        hasValidateInfo.kindcodes = this.currentCodeInfo.kindcodes;
        hasValidateInfo.goodsMap = this.currentCodeInfo.goodsMap;
      } else {
        this.cardVertifyData.push(this.currentCodeInfo);
      }

      this.currentCodeInfo = null;

      // 清空表单
      this.serviceForm.cardCode = "";
      this.serviceForm.cardSerial = "";

      Api.SETCARDGOODS(param).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: res.data.message });
          return;
        }
      });
    },
    memberSelected: function(memberInfo) {
      this.bindMemberInfo = memberInfo;
    },
    //删除券卡验证行
    deleteRow(index) {
      Api.REMOVEVALIDATEDCARD({ code: this.cardVertifyData[index].code }).then(
        res => {
          let data = res.data;
          if (data.status === "200") {
            this.cardVertifyData.splice(index, 1);
          } else {
            Message.error({ message: data.message });
          }
        }
      );
    },
    // 打开选择可选商品弹窗
    getShowChoseGoods(item) {
      this.currentCode = item.code;
      this.currentUseTimes = item.consumpteTimes;
      this.currentCodeInfo = item;
      this.firstTimes = false;
      this.goodsChoseDialogVisible = true;
    },
    // 关闭选择可选商品弹窗
    getCloseGoodsCld() {
      if (
        this.firstTimes &&
        this.currentCodeInfo &&
        this.currentCodeInfo.code
      ) {
        Api.REMOVEVALIDATEDCARD({ code: this.currentCodeInfo.code }).then(
          res => {
            let data = res.data;
            if (data.status === "200") {
              this.goodsChoseDialogVisible = false;
            } else {
              Message.error({ message: data.message });
            }
          }
        );
      } else {
        this.goodsChoseDialogVisible = false;
      }
    },
    // 打开选择会员弹窗
    getShowChoseMem(val) {
      if (val) {
        this.memberBox = true;
      } else {
        this.memberBox = !this.bindMemberInfo;
        this.bindMemberInfo = null;
      }
      if (this.memberBox) {
        this.memberChoseDialogVisible = true;
      }
    },
    // 关闭选择会员弹窗
    getCloseMemberCld() {
      this.memberChoseDialogVisible = false;
    },
    getSubmit() {
      let jinshizun = this.ElementControls('jinshizun'); 
      if (jinshizun == 1) {
        return Api.JINSHIZUNSUBMITORDER;
      }
      return Api.SUBMITORDER;
    },
    //提交表单
    submitDeliveryForm() {
      if(this.cardVertifyData.length==0){
        this.$message.error('请先验证券卡，并设置好提货商品！')
        return
      }
      this.submitLoading = true;
      let param = {
        delimode: 0,
        terminaltype: 0
      };
      this.getSubmit()(param).then(res => {
         if (res.data.status === "200") {
          this.orderno = res.data.data.orderno;
          this.submitDeliveryBox = true;
          this.$refs.codeRef.focus();
        } else {
          Message.error({ message: res.data.message });
        }
        this.initPick();
        this.submitLoading = false;
      });
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.cvTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 140;
    },
    initPick: function() {
      this.cardVertifyData = [];
      Api.INITIALIZE({ delimode: 0 }).then(res => {
        if (res.data.status !== "200") {
          Message.error({ message: "提货初始化失败，请刷新重试！" });
        }
      });
    },
    //关闭商品汇总弹窗
    getCloseSummaryBox(){
      this.cardOrderno = '';
      this.goodsSummary = false;
      this.$refs.codeRef.focus();
    },
    //查看订单详情
    orderCardInfo(){
      this.cardOrderno = this.orderno;
      this.submitDeliveryBox = false;
      this.goodsSummary = true;
    },
    // 关闭订单详情弹窗
    closeSubmitPop() {
      this.cardOrderno = '';
      this.submitDeliveryBox = false;
       this.$refs.codeRef.focus();
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
    // 预售配置
    this.presellconfig = this.config.getPresellconfig();
    // 公共配置
    this.pubordprintinfo = this.config.getPubordprintinfo();
  },
  mounted() {
    if (localStorage.getItem("userInfoMd")) {
      this.ischeckpwd = JSON.parse(
        localStorage.getItem("userInfoMd")
      ).ischeckpwd;
    }
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
    }, 200);
    this.initPick();
    this.$nextTick(() => {
           this.$refs.codeRef.focus();
        })
  },
  computed: {
    serviceTypeData: function() {
      let serviceTypeData = [];
      let cuspickway = this.pubordprintinfo.cuspickway;
      serviceTypeData.push({ name: "卡号", value: 0 });
      // if (cuspickway === 1) {
      //   serviceTypeData.push({ name: "序列号", value: 1 });
      // }
      // 设置默认提货方式
      // this.serviceForm.verifyType = this.pubordprintinfo.defcuspickway;

      return serviceTypeData;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
};
</script>
<style scoped>
@import "Css/Style.css";
/* .memberwidth {
  width: calc(100% - 102px) !important;
  max-width: unset;
} */
/*商品汇总start */
.goodsSummary {margin-left:30px;color:var(--main-color);font-size: 14px;}
.goodsSummary:before {padding-right:5px;}
.goodsSummary:hover {opacity:.8;}
/*确认提示框 */
.alertMsgDlog >>> .el-dialog {width:420px;border-radius:4px;overflow: hidden;padding-bottom:20px;}
.alertBox {position:relative;width:70%;margin:0 auto; padding:17px 10px 17px 36px;}
.alertBox .el-icon-success{position:absolute; left:0; top:15px;color:#67C23A;font-size: 24px;}
.msgBtns {text-align: center;padding:5px 15px 0;}
.alertMsgDlog small {color:#999;font-size: 12px;padding:10px 0;}
/*商品汇总end */
</style>





// WEBPACK FOOTER //
// src/views/OrderFolder/cardDeliery.vue